module.exports = __webpack_public_path__ + "img/downloadApp25.7d9ea02a.svg";